<template>
  <div class="animated fadeIn" style="margin-left: 40px;margin-right: 40px;">
    <div class="row">
      <div class="col-sm-8 col-lg-4">
        <div class="social-box twitter">
          <div class="plfx">会员数</div>
          <ul>
            <li>
              <strong>{{gzhmember}}</strong>
              <span style="color:#a1a4a3;">公众号</span>
            </li>
            <li>
              <strong>{{membercount}}</strong>
              <span style="color:#a1a4a3;">小程序</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-sm-8 col-lg-4">
        <div class="social-box linkedin">
          <div class="plkh">产品库</div>
          <ul>
            <li style="width:100%;">
              <strong>{{goodscount}}</strong>
              <span style="color:#a1a4a3;">总数</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-sm-8 col-lg-4">
        <div class="social-box google-plus">
          <div class="plhy">订单</div>
          <ul>
            <li>
              <strong>{{neworder}}</strong>
              <span style="color:#a1a4a3;">新增</span>
            </li>
            <li>
              <strong>{{ordercount}}</strong>
              <span style="color:#a1a4a3;">总数</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div id="mymainChart" class="card">
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
Vue.prototype.$http = axios
var that
export default {
  name: 'dashboard',
  data () {
    return {
      monthsalecount: 0,
      salecount: 15,
      gzhmember: 0,
      membercount: 0,
      newcourse: 0,
      coursecount: 0,
      newgoods: 0,
      goodscount: 0,
      neworder: 0,
      ordercount: 0
    }
  },
  components: {

  },
  mounted () {
    that = this
    that.getmember()
    that.getgoods()
    that.getordercount()
    that.queryorder()
  },
  methods: {
    drawLine (tmpdata) {
      var xdata = []
      var ydata = []
      for (var i = 0; i < tmpdata.length; i++) {
        xdata.push(tmpdata[i].op_time)
        ydata.push(tmpdata[i].count_price)
      }
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById('mymainChart'))
      // 绘制图表
      myChart.setOption({
        legend: {
          data: ['业绩金额']
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xdata
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: ydata,
          type: 'line'
        }]
      })
      window.onresize = myChart.resize
    },
    getmember: function () {
      var qstrinfo = {
        whereinfo: ' openid is not null',
        limit: '',
        sortinfo: ''
      }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querywxcount',
          method: 'post',
          data: qstrinfo,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.membercount = res.data[0].count
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      var qstrinfo1 = {
        whereinfo: ' openid is not null',
        limit: '',
        sortinfo: ''
      }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querywxgzhcount',
          method: 'post',
          data: qstrinfo1,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.gzhmember = res.data[0].count
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
    },
    getgoods: function () {
      var qstrinfo = {
        whereinfo: ' id > 0',
        limit: '',
        sortinfo: ''
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/querygoodscount',
        method: 'post',
        data: qstrinfo,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.goodscount = res.data[0].count
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    getordercount: function () {
      var qstrinfo = {
        whereinfo: ' order_no is not null',
        limit: '',
        sortinfo: ''
      }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryordercount',
          method: 'post',
          data: qstrinfo,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.ordercount = res.data[0].count
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      console.log(fundate(-30))
      var date = new Date()
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      console.log(currentdate)
      var timeqstr = " state_id>=2 and op_time >= '" + fundate(-30) + " 00:00:00' and op_time <='" + currentdate + " 23:59:59'"
      console.log(timeqstr)
      var qstrinfo1 = {
        whereinfo: timeqstr,
        limit: '',
        sortinfo: ''
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryordercount',
        method: 'post',
        data: qstrinfo1,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            window.console.log('新订单',res.data)
            that.neworder = res.data[0].count
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })

      console.log(currentdate)
    },
    queryorder () {
      var qstr = " ownphone='" + localStorage.getItem('username') + "' and  type_id != 3"
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorder',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            window.console.log(res.data)
            that.drawLine(res.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorderex',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.orderexdata = res.data
            window.console.log('扩展信息')
            window.console.log(that.orderexdata)
          } else {
            that.orderexdata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function fundate (aa) {
  var date1 = new Date()
  var time1 = date1.getFullYear() + '-' + (date1.getMonth() + 1) + '-' + date1.getDate()
  console.log('time1')
  console.log(time1)
  var date2 = new Date(date1)
  date2.setDate(date1.getDate() + aa)
  var month = date2.getMonth() + 1
  var strDate = date2.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var time2 = date2.getFullYear() + '-' + month + '-' + strDate
  console.log('time2')
  console.log(time2)
  return time2
}
</script>
<style>
  .el-form-item {
    margin-bottom: 0px;
  }
  .card {
    height: 600px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue